// eslint-disable-next-line filenames/match-regex
import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import dataLayer from '@rover/globals/dataLayer';
import moment from '@rover/globals/moment';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';
import reportError from '@rover/utilities/reportError';
// WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'
import DF from '@rover/shared/js/constants/i18n/datetime/datetimeInjected';
import APIError from '@rover/react-lib/apis/APIError';
import fullCalendarRoverInit from './fullcalendar_rover_view_init';

fullCalendarRoverInit();

export default Backbone.View.extend({
  initialize(options) {
    _.bindAll(
      this,
      'getDataKey',
      'getActiveService',
      'changeServiceType',
      'viewRender',
      'parseAvailability',
      'getEventsDataPromise',
      'formatAvailabilityData'
    );
    this.availability = {};
    this.eventsList = [];
    this.calendarApi = options.calendarApi || '';
    this.data = [];
    return this;
  },

  fetchEvents(start, end, timezone, callback) {
    this.$el.addClass('rover-loading');
    if ($('.service-type-selector')) {
      $('.service-type-selector').prop('disabled', true);
    }
    this.getEventsDataPromise(start, end)
      .then(this.formatAvailabilityData)
      .then(this.parseAvailability)
      .then(callback);
  },

  getDataKey(start, end) {
    return `${start.format()}|${end.format()}`;
  },
  getEventsDataPromise(start, end) {
    const key = this.getDataKey(start, end);
    // Return the cached response for this start and end date if it exists
    if (this.data[key]) {
      return new Promise(resolve => {
        resolve(this.data[key]);
      });
    }

    // fetch the events from the calendar api endpoint
    return new Promise((resolve, reject) => {
      let getParams;
      if (start.isValid()) {
        getParams = {
          start_date: this.formatDate(start),
          end_date: this.formatDate(end),
        };
      } else {
        getParams = { end_date: this.formatDate(end) };
        reportError(`Trying to fetch calendar, but the start_date "${start.format()}" is invalid`);
      }

      $.get(this.calendarApi, getParams)
        .done(data => {
          this.data[key] = data;
          resolve(data);
        })
        .fail((jqXHR, textStatus, error) => {
          const statusCode = jqXHR.status;
          // jQuery's XHR will sometimes fail with a status code of `0` [definitely not a valid HTTP status code]
          // (see https://github.com/jquery/jquery/blob/b14ce54334a568eaaa107be4c441660a57c3db24/src/ajax/xhr.js#L86)
          // This can happen for all sorts of reasons (https://stackoverflow.com/questions/2000609/why-is-ajax-returning-http-status-code-0),
          // but they either do not apply (invalid requests) or are things we cannot control (navigating away from the page).
          if (statusCode === 0) {
            // Ignore the error, resolve with empty data, and exit early.
            resolve({});
            return;
          }

          const responseText = jqXHR.responseJSON
            ? JSON.stringify(jqXHR.responseJSON, null, 2)
            : jqXHR.responseText;
          const message = `Error fetching calendar: ${error} (${statusCode}).
Tried fetching from ${this.calendarApi},
with params ${JSON.stringify(getParams)}
Response:
${responseText}`;
          reject(new APIError(message, statusCode));
        });
    });
  },
  changeServiceType() {
    this.availability = {};
    this.eventsList = [];
    this.$el.addClass('rover-loading');
    $('.rover-has-event').removeClass('rover-has-event');

    this.displaySelectedServiceDescription();
    this.$el.fullCalendar('refetchEvents');
  },
  displaySelectedServiceDescription() {
    // This is a temporary fix for the Initial Sitter quality team
    // that relies on the old behavior (of showing the capacity
    // for all the services). This should be removed once they have
    // specific tooling for their workflow
    if (Rover.context.isViewedByStaffUser) {
      return;
    }

    // Show only the availability description and cancellation policy
    // for the selected service
    const activeService = this.getActiveService();
    $('[data-selected-service]').hide();
    $(`*[data-selected-service="${activeService}"]`).show();
  },
  formatAvailabilityData(data) {
    return new Promise(resolve => {
      const availabilityData = {};
      if (data.preferences) {
        data.preferences.forEach(el => {
          const service = {
            id: el.calendar_id,
          };
          availabilityData[el.name] = service;

          data.availability.forEach(dates => {
            const currentDate = _.findWhere(dates.calendars, {
              calendar_id: service.id,
            });
            let spaceAvailable = currentDate ? currentDate.spaces_available : 0;
            if (el.accepts_more_than_one_client === false && currentDate.spaces_occupied > 0) {
              spaceAvailable = 0;
            }
            service[dates.date] = { count: spaceAvailable };
          });
        });
      }

      resolve(availabilityData);
    });
  },
  getActiveService() {
    const st = $('.service-type-selector');
    return st ? st.val() : null;
  },
  parseAvailability(availability) {
    return new Promise(resolve => {
      const availDates = [];
      const activeService = this.getActiveService();

      Object.keys(availability).forEach(service => {
        Object.keys(availability[service]).forEach(date => {
          if (availability[service][date].count > 0) {
            if (service === activeService && availDates.indexOf(date) === -1) {
              availDates.push(date);
            }
            this.availability[service] = this.availability[service] || [];
            this.availability[service].push(date);
          }
        });
      });
      availDates.forEach(date => {
        this.eventsList.push({
          start: date,
          end: date,
          rendering: 'background',
          allDay: true,
        });
      });

      this.$el.removeClass('rover-loading');
      if ($('.service-type-selector')) {
        $('.service-type-selector').prop('disabled', false);
      }
      resolve(this.eventsList);
    });
  },

  formatDate(momentObject) {
    return momentObject.format(DF.DATE_ISO);
  },

  viewRender(view) {
    const maxDate = moment.utc().add(Rover.context.maxDaysInFuture, 'days');
    const today = moment.utc();
    const isShowingMaxFutureDayOrAfter =
      view.intervalEnd.isAfter(maxDate, 'day') || view.intervalEnd.isSame(maxDate, 'day');
    const isShowingTodayOrBefore =
      view.intervalStart.isBefore(today, 'day') || view.intervalStart.isSame(today, 'day');
    this.$('.fc-next-button').prop('disabled', isShowingMaxFutureDayOrAfter);
    this.$('.fc-prev-button').prop('disabled', isShowingTodayOrBefore);
  },
  render() {
    this.$el.addClass('rover-full-calendar');
    $.fullCalendar.lang(moment.locale());
    this.$el.fullCalendar({
      theme: false,
      buttonIcons: {
        prev: ' rover-icon rover-icon-page-left',
        next: ' rover-icon rover-icon-page-right',
      },
      titleFormat: DF.MONTH_YEAR_FULL,
      header: {
        left: 'title',
        center: '',
        right: 'prev,next',
      },
      defaultView: 'rover',
      fixedWeekCount: false,
      contentHeight: 'auto',
      timezone: 'UTC',
      viewRender: this.viewRender,
      eventAfterRender: function eventAfterRender(event) {
        const $lastTableLastEvent = $('.fc-week:last .fc-bgevent-skeleton:last td:last');
        const $lastTableFirstEvent = $('.fc-week:last .fc-bgevent-skeleton:first td:first');

        if (
          $lastTableLastEvent.length &&
          $lastTableLastEvent.offset().top === $('.last-sat').offset().top &&
          $lastTableLastEvent.offset().left === $('.last-sat').offset().left
        ) {
          $lastTableLastEvent.addClass('last-sat');
        }

        if (
          $lastTableFirstEvent.length &&
          $lastTableFirstEvent.offset().top === $('.last-sun').offset().top &&
          $lastTableFirstEvent.offset().left === $('.last-sun').offset().left
        ) {
          $lastTableFirstEvent.addClass('last-sun');

          if ($lastTableFirstEvent.attr('colspan') === '7') {
            $lastTableFirstEvent.addClass('last-sat');
          }
        }

        const format = DF.DATE_ISO;
        const elemTD = $(`[data-date="${event.start.format(format)}"]`);
        if (event.start) {
          elemTD.addClass('rover-has-event');
        }
      },
      eventSources: [_.bind(this.fetchEvents, this)],
    });

    $('.fc-view-container').off('click.dataLayer');
    $('.fc-view-container').on('click.dataLayer', () => {
      dataLayer.push({
        event: 'profile-calendar-click',
      });
    });

    $('.rover-icon-page-right').off('click.dataLayer');
    $('.rover-icon-page-right').on('click.dataLayer', () => {
      dataLayer.push({
        event: 'owner-conversion-member-profile-calendar-interact',
        interactionType: 'forward',
        providerId: Rover.context.providerId,
      });
    });

    $('.rover-icon-page-left').off('click.dataLayer');
    $('.rover-icon-page-left').on('click.dataLayer', () => {
      dataLayer.push({
        event: 'owner-conversion-member-profile-calendar-interact',
        interactionType: 'back',
      });
    });
    this.displaySelectedServiceDescription();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/mempro/availability_calendar_view.js